<template>
    <b-card :style="{'max-width': '1024px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text>
            <h4>Lookup Inventory</h4>
        </b-card-text>

        <b-card>
            <b-form @submit="fetch_data">
                <div style="display: inline-block; width: 250px;">
                    <b-form-input size="sm" v-model="product_query" placeholder="Enter SKU"></b-form-input>
                </div>
            <b-button size="sm" @click="fetch_data">SEARCH</b-button>
            </b-form>

        </b-card>


        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm" style="margin-top: 10px;">
            <div v-if="items.length > 0" style="margin-top: 10px; overflow-x: auto;">
                <table style="width: 100%;">

                    <thead>
                        <tr>
                            <th class="ipt_tdhr" @click="sortby('product_sku')" style="min-width: 100px;">
                                SKU
                            </th>
                            <th class="ipt_tdhr" @click="sortby('product_name')" style="min-width: 150px;">
                                NAME
                            </th>
                            <th class="ipt_tdhr" @click="sortby('locsub')" style="min-width: 150px;">
                                LOCATION
                            </th>
                            <th class="ipt_tdhr" @click="sortby('nitems')" style="min-width: 50px;">
                                QTY
                            </th>
                            <th class="ipt_tdhr" @click="sortby('reserved')" style="min-width: 50px;">
                                RESERVED
                            </th>
                            <th class="ipt_tdhr" @click="sortby('available')" style="min-width: 50px;">
                                AVAILABLE
                            </th>
                            <th class="ipt_tdhr" style="min-width: 50px;">
                                ACTION
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <td class="ipt_tdhr" style="font-weight: normal; background-color: lightyellow;"></td>
                          <td class="ipt_tdhr" style="font-weight: normal; background-color: lightyellow;"></td>
                          <td class="ipt_tdhr" style="font-weight: normal; background-color: lightyellow;"></td>
                          <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;">
                              {{ total('nitems') }}
                          </td>
                          <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;">
                              {{ total('reserved') }}
                          </td>
                          <td class="ipt_tdhr" style="font-weight: bold; background-color: lightyellow;">
                              {{ total('available') }}
                          </td>
                          <td class="ipt_tdhr" style="font-weight: normal; background-color: lightyellow;"></td>
                        </tr>
                        <tr v-for="item,idx in items" v-bind:key="idx">
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ item.product_sku }}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ item.product_name }}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <div v-if="item.locsub">
                                    {{ packet.locsubsdict[item.locsub] }}
                                </div>
                                <div v-else>
                                    N/A
                                </div>
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                <b-input size="sm" style="width: 100px; margin: auto; text-align: center;" v-model="item.nitems" :disabled="item.is_out_of_stock || packet.userDetails.userrole != 'admin'"></b-input>
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                        {{ (item.reserved || 0) }}
                            </td>
                            <td class="ipt_tdhr" style="font-weight: normal;">
                                {{ (item.available || 0) }}
                            </td>

                            <td class="ipt_tdhr">
                                <b-button size="sm" variant="outline-success" :disabled="item.is_out_of_stock || packet.userDetails.userrole != 'admin'" @click="update_inventory(item)">UPDATE</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <b-alert show variant="warning">{{message}}</b-alert>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "LookupInventory",
        props: [],
        components: {},
        data: function(){
            return {
                packet: {},
                product_query: null,
                message: "No item to show",
                items_being_loaded: false,
                items: [],
                sort_asc: false,
            }
        },
        methods: {
            fetch_data: function(e){
                if (e){
                    e.preventDefault()
                }

                if (!this.product_query || this.product_query.length <= 1){
                    this.$vex.dialog.alert({
                        message: "Please type a more specific name OR sku greater than 1 characters."
                    });
                    return
                }
                let path = "/api/inventory/loc_sub_product_inventory/"
                let data = {product_query: this.product_query}
                if (this.packet.userDetails.properties.location_id){
                    data.location_id = this.packet.userDetails.properties.location_id;
                }
                let that = this
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading inventory numbers.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            update_inventory: function(item){
                let path = "/api/inventory/loc_sub_product_inventory_update/"
                let data = item
                let that = this
                if (isNaN(parseInt(item.nitems))){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid quantity >= 0."
                    });
                    return
                }
                item.nitems = parseInt(item.nitems)
                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating inventory numbers.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postSyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            },
            total: function(key, qty) {
                return this.items.reduce((sum, d) => {
                    const value = Number(d[key]) || 0;
                    if (qty) {
                        const inStock = Number(d.in_stock) || 0;
                        return sum + value * inStock;
                    }
                    return sum + value;
                }, 0);
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Inventory/LookupInventory.vue